const calcChildrenHeight = (el) => {
  let commonHeight = 0;

  if (el.children) {
    [...el.children].forEach((child) => {
      commonHeight += child.clientHeight;
    });
  }
  return commonHeight;
};

export const setMaxHeightStyle = (selector) => {
  const items = document.querySelectorAll(selector);

  if (items) {
    items.forEach((item) => {
      const innerHeight = calcChildrenHeight(item);

      item.style.maxHeight = `${innerHeight}px`;
    });
  }
};
